import {useState} from 'react';
import {useAppContext} from "../../utils/AppContext";

const Faqs = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const {
        projectData, 
        screenSize,
    } = useAppContext();

    // Styles Configuration //
    const faqContainer = (!screenSize) ? 'faq-container' : `faq-container faq-container${screenSize}`;
    const sectionTitle = (!screenSize) ? "section-title" : `section-title section-title${screenSize}`;
    const faqItemsContainer = (!screenSize) ? "faq-items-container" : `faq-items-container faq-items-container${screenSize}`;
    const faqItemContainer = (!screenSize) ? "faq-item-container" : `faq-item-container faq-item-container${screenSize}`;
    const faqQuestionButton = (!screenSize) ? "faq-question-button" : `faq-question-button faq-question-button${screenSize}`;
    const itemTitle = (!screenSize) ? "item-title" : `item-title item-title${screenSize}`;
    const faqAnswerContainer = (!screenSize) ? "faq-answer-container" : `faq-answer-container faq-answer-container${screenSize}`;
    const smallTextLight = (!screenSize) ? "small-text-light" : `small-text-light small-text-light${screenSize}`;

    const renderFaqItem = ({item, index}) => (
        <div
            className={faqItemContainer}
            key={index}
        >
            <button
                className={faqQuestionButton}
                onClick={() => setActiveIndex(index)}
            >
                <span className={itemTitle}>{item.question}</span>
            </button>
            {(activeIndex !== null && activeIndex === index) && (
                <div className={faqAnswerContainer}>
                    <p className={smallTextLight}>{item.answer}</p>
                </div>
            )}
        </div>
    );

    return (
        <div className={faqContainer}>
            <h2 className={sectionTitle}>FAQ</h2>
            <div className={faqItemsContainer}>
                {projectData.faq.items.map((item, index) => (
                    renderFaqItem({item, index})
                ))}
            </div>
        </div>
    );

};

export default Faqs;
